import { useEffect, useState } from 'react';

import { useLazyGetCourtBookingQuery } from '../store/Api';
import { CourtBooking } from '../store/types';

interface Props {
  bookingIds: number[] | null;
}

export function useGetBookingDetail({ bookingIds }: Props) {
  const [courtBookingDetail, setCourtBookingDetail] = useState<CourtBooking>();
  const [getBookedCourtInfo, { data: dataCourtBookingDetail, isLoading: isBookingLoading }] = useLazyGetCourtBookingQuery();

  useEffect(() => {
    if (bookingIds !== null) {
      (async () => {
        for (const bookingid of bookingIds) {
          await getBookedCourtInfo(bookingid);
        }
      })();
    }
  }, [bookingIds, getBookedCourtInfo]);

  useEffect(() => {
    if (dataCourtBookingDetail === undefined) {
      return;
    }

    if (courtBookingDetail === undefined) {
      setCourtBookingDetail({
        ...dataCourtBookingDetail
      });
      return;
    }

    const currentBookings = courtBookingDetail?.userIds;
    if (!currentBookings.includes(dataCourtBookingDetail.userIds?.[0])) {
      setCourtBookingDetail({
        ...dataCourtBookingDetail,
        userNames: [...courtBookingDetail?.userNames ?? null, ...dataCourtBookingDetail?.userNames ?? null],
        coachBookingIds: [...courtBookingDetail?.coachBookingIds ?? null, ...dataCourtBookingDetail?.coachBookingIds ?? null],
        coachNames: [...courtBookingDetail?.coachNames ?? null, ...dataCourtBookingDetail?.coachNames ?? null],
        userIds: [...courtBookingDetail?.userIds ?? null, ...dataCourtBookingDetail?.userIds ?? null],
        priceDetails: [...courtBookingDetail.priceDetails, ...dataCourtBookingDetail.priceDetails],
        price: [...courtBookingDetail.price, ...dataCourtBookingDetail.price],
        usersHasDeposite: [...courtBookingDetail.usersHasDeposite, ...dataCourtBookingDetail.usersHasDeposite],
      });
    } else {
      setCourtBookingDetail({
        ...courtBookingDetail,
        confirmed: dataCourtBookingDetail.confirmed,
        courtId: dataCourtBookingDetail.courtId,
        note: dataCourtBookingDetail.note
      });
    }
  }, [dataCourtBookingDetail, setCourtBookingDetail]);
  return ({
    courtBookingDetail,
    isBookingLoading
  });
}

